import template from './card.html';
class CardComponent {

}


export default {
    template: template,
    controller: CardComponent,
    bindings:{
        repository: '='
    }
};


// WEBPACK FOOTER //
// ./components/card/card.component.js